import * as React from 'react';
import { useForkRef } from '../../../hooks';
import { Paper, PaperProps } from '../../Paper';
import { Scroller, ScrollerProps } from '../../Scroller';
import { Sticky } from '../../Sticky';
import { useScrollspyContext } from '../Scrollspy.context';

export interface ScrollspyNavigationProps extends ScrollerProps {
    /**
     * The content of the component.
     */
    children: React.ReactNode;

    /**
     * Additional properties applied to the surface Paper component.
     */
    SurfaceProps?: PaperProps;
}

export function ScrollspyNavigation(props: Readonly<ScrollspyNavigationProps>): React.JSX.Element {
    const { children, SurfaceProps, ref, ...other } = props;

    const { navigationRef, isNavigationStuck, onNavigationStuckChange } = useScrollspyContext();

    const handleRef = useForkRef(navigationRef, ref);

    const handleSticky = React.useCallback(
        (stuck: boolean) => () => {
            if (stuck !== isNavigationStuck) {
                onNavigationStuckChange?.(stuck);
            }
        },
        [isNavigationStuck, onNavigationStuckChange]
    );

    const stuckProps: Partial<PaperProps> = {
        shadow: 'm',
        btlr: 0,
        btrr: 0,
    };

    return (
        <Sticky onStick={handleSticky(true)} onUnstick={handleSticky(false)}>
            <Paper ref={handleRef} p={3} {...(isNavigationStuck && stuckProps)} radius="s" {...SurfaceProps}>
                <Scroller spacing={4} {...other}>
                    {children}
                </Scroller>
            </Paper>
        </Sticky>
    );
}
